<template>
  <div v-if="result || error">
    <!-- Success -->
    <div v-if="result" class="res-ok">
      <div class="res-head">
        <svg viewBox="0 0 20 20" fill="#059669"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
        <div>
          <div class="res-title">{{ result.message || 'Ký số thành công' }}</div>
          <div class="res-file">{{ result.fileName || 'signed.pdf' }}</div>
        </div>
      </div>
      <div class="res-actions">
        <button class="act-btn act-btn--view" @click="openPreview">
          <svg viewBox="0 0 16 16" fill="currentColor"><path d="M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z"/><path fill-rule="evenodd" d="M1.38 8.28a.87.87 0 010-.56C2.6 5.22 5.06 3.5 8 3.5s5.4 1.72 6.62 4.22a.87.87 0 010 .56C13.4 10.78 10.94 12.5 8 12.5S2.6 10.78 1.38 8.28zM11 8a3 3 0 11-6 0 3 3 0 016 0z" clip-rule="evenodd"/></svg>
          Xem
        </button>
        <button class="act-btn act-btn--dl" @click="onDownload">
          <svg viewBox="0 0 16 16" fill="currentColor"><path d="M.5 9.9a.5.5 0 01.5.5v2.5a1 1 0 001 1h12a1 1 0 001-1v-2.5a.5.5 0 011 0v2.5a2 2 0 01-2 2H2a2 2 0 01-2-2v-2.5a.5.5 0 01.5-.5z"/><path d="M7.646 11.854a.5.5 0 00.708 0l3-3a.5.5 0 00-.708-.708L8.5 10.293V1.5a.5.5 0 00-1 0v8.793L5.354 8.146a.5.5 0 10-.708.708l3 3z"/></svg>
          Tải
        </button>
      </div>
    </div>

    <!-- Error -->
    <div v-if="error" class="res-err">
      <svg viewBox="0 0 20 20" fill="#dc2626"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/></svg>
      <span>{{ error }}</span>
    </div>

    <!-- Preview được tạo bằng JS và mount vào body -->
  </div>
</template>

<script>
export default {
  name: 'SignResult',
  props: {
    result: { type: Object, default: null },
    error: { type: String, default: null }
  },
  data() { return { showPreview: false } },
  computed: {
    pdfPreviewUrl() {
      if (!this.result) return ''
      if (this.result.signedPdfBase64) return 'data:application/pdf;base64,' + this.result.signedPdfBase64
      if (this.result.downloadUrl) return this.result.downloadUrl
      return ''
    }
  },
  beforeDestroy: function () {
    this.closePreview()
  },
  methods: {
    openPreview() {
      this.closePreview()
      var self = this
      // Tạo overlay hoàn toàn bằng JS, append trực tiếp vào body
      var overlay = document.createElement('div')
      overlay.id = 'vgca-preview-overlay'
      overlay.style.cssText = 'position:fixed;top:0;left:0;width:100vw;height:100vh;background:rgba(0,0,0,0.95);z-index:2147483647;display:flex;flex-direction:column;'

      // Toolbar
      var bar = document.createElement('div')
      bar.style.cssText = 'display:flex;align-items:center;justify-content:space-between;padding:10px 20px;background:#1e293b;border-bottom:1px solid #334155;flex-shrink:0;'
      bar.innerHTML = '<span style="font-size:14px;font-weight:600;color:#f1f5f9;">Văn bản đã ký</span>'

      var actions = document.createElement('div')
      actions.style.cssText = 'display:flex;gap:8px;'

      var dlBtn = document.createElement('button')
      dlBtn.textContent = 'Tải về'
      dlBtn.style.cssText = 'padding:6px 16px;border:1px solid #475569;border-radius:6px;background:#334155;font-size:13px;color:#e2e8f0;cursor:pointer;'
      dlBtn.onclick = function () { self.onDownload() }

      var closeBtn = document.createElement('button')
      closeBtn.innerHTML = '&times; Đóng'
      closeBtn.style.cssText = 'padding:6px 16px;border:1px solid #7f1d1d;border-radius:6px;background:#450a0a;font-size:13px;color:#f87171;cursor:pointer;'
      closeBtn.onclick = function () { self.closePreview() }

      actions.appendChild(dlBtn)
      actions.appendChild(closeBtn)
      bar.appendChild(actions)
      overlay.appendChild(bar)

      // Iframe
      var iframe = document.createElement('iframe')
      iframe.src = this.pdfPreviewUrl
      iframe.style.cssText = 'flex:1;border:none;background:#fff;'
      overlay.appendChild(iframe)

      document.body.appendChild(overlay)
      this.showPreview = true
    },
    closePreview() {
      this.showPreview = false
      var el = document.getElementById('vgca-preview-overlay')
      if (el) el.remove()
    },
    onDownload() {
      if (!this.result) return
      // Nếu có fileId → emit cho parent xử lý
      if (this.result.fileId) {
        this.$emit('download', this.result.fileId, this.result.fileName)
        return
      }
      // Nếu có base64 → download trực tiếp
      if (this.result.signedPdfBase64) {
        var byteChars = atob(this.result.signedPdfBase64)
        var byteArr = new Uint8Array(byteChars.length)
        for (var i = 0; i < byteChars.length; i++) byteArr[i] = byteChars.charCodeAt(i)
        var blob = new Blob([byteArr], { type: 'application/pdf' })
        var url = window.URL.createObjectURL(blob)
        var link = document.createElement('a')
        link.href = url
        link.download = this.result.fileName || 'signed.pdf'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    }
  }
}
</script>

<style scoped>
.res-ok {
  padding:10px 12px; background:#f0fdf4; border:1px solid #bbf7d0; border-radius:8px;
}
.res-head { display:flex; align-items:center; gap:8px; margin-bottom:8px; }
.res-head svg { width:20px; height:20px; flex-shrink:0; }
.res-title { font-size:13px; font-weight:600; color:#166534; }
.res-file { font-size:11px; color:#059669; }
.res-actions { display:flex; gap:6px; }
.act-btn {
  padding:5px 12px; border-radius:5px; border:none;
  font-size:12px; font-weight:500; cursor:pointer; font-family:inherit;
  display:flex; align-items:center; gap:4px; transition:all 0.15s;
}
.act-btn svg { width:13px; height:13px; }
.act-btn--view { background:#e6f2f8; color:#003d63; }
.act-btn--view:hover { background:#cce5f0; }
.act-btn--dl { background:#166534; color:#fff; }
.act-btn--dl:hover { background:#15803d; }

.res-err {
  display:flex; align-items:center; gap:8px;
  padding:8px 12px; background:#fef2f2; border:1px solid #fecaca; border-radius:6px;
  font-size:12px; color:#991b1b;
}
.res-err svg { width:16px; height:16px; flex-shrink:0; }

.pdf-iframe { flex:1; border:none; background:#fff; }
</style>

<!-- Unscoped styles cho modal overlay (mounted vào body) -->
<style>
.vgca-pdf-overlay {
  position:fixed !important;
  top:0 !important; left:0 !important; right:0 !important; bottom:0 !important;
  background:rgba(0,0,0,0.92) !important;
  z-index:2147483647 !important;
  display:flex !important;
  flex-direction:column !important;
}
.vgca-pdf-overlay .vgca-pdf-modal {
  width:100%; height:100%;
  display:flex; flex-direction:column;
}
.vgca-pdf-overlay .vgca-pdf-bar {
  display:flex; align-items:center; justify-content:space-between;
  padding:10px 20px; background:#1e293b; border-bottom:1px solid #334155;
  font-size:14px; font-weight:600; color:#f1f5f9;
  flex-shrink:0; z-index:1;
}
.vgca-pdf-overlay .vgca-pdf-bar-actions { display:flex; gap:8px; }
.vgca-pdf-overlay .vgca-bar-btn {
  padding:6px 16px; border:1px solid #475569; border-radius:6px;
  background:#334155; font-size:13px; color:#e2e8f0; cursor:pointer; font-family:inherit;
  transition:all 0.15s; display:flex; align-items:center;
}
.vgca-pdf-overlay .vgca-bar-btn:hover { background:#475569; color:#fff; }
.vgca-pdf-overlay .vgca-bar-btn--close { color:#f87171; border-color:#7f1d1d; background:#450a0a; }
.vgca-pdf-overlay .vgca-bar-btn--close:hover { background:#7f1d1d; color:#fecaca; }
.vgca-pdf-overlay .vgca-pdf-iframe { flex:1; border:none; background:#fff; }
</style>
